import { useEffect, useState } from 'react'
import { useQuery, useMutation } from 'react-query'
import API from '.'

const ENDPOINT = '/auth'
const QUERY_KEY = 'auth'

export const useLogin = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/login`, data), config)

export const useLogout = (config = {}) => useMutation(() => API.post(`${ENDPOINT}/logout`), config)

export const useMe = () => {
  const [user, setUser] = useState(null)
  const [firstRun, setFirstRun] = useState(true)
  const [enabled, setEnabled] = useState(true)
  const { isFetched, error, refetch } = useQuery(
    QUERY_KEY,
    async () => (await API.get(`${ENDPOINT}/me`)).data,
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: true,
      onSuccess: setUser,
    }
  )

  useEffect(() => {
    if (isFetched && firstRun) {
      setFirstRun(false)
    }
  }, [isFetched, firstRun])

  const fetchUser = async () => {
    //queryClient.invalidateQueries(QUERY_KEY_ME)
    refetch()
  }

  const clearUser = () => {
    setUser(null)
  }

  return {
    firstRun,
    setFirstRun,
    user,
    setUser,
    fetchUser,
    clearUser,
    error: error?.response?.status === 401 ? undefined : error,
    enabled,
    setEnabled,
  }
}

export const useForgotPassword = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/forgot-password`, data), config)

export const useResetPassword = (config = {}) =>
  useMutation((data) => API.patch(`${ENDPOINT}/reset-password`, data), config)
